import { render, staticRenderFns } from "./GuidelineCoFactor.vue?vue&type=template&id=80c5221e&scoped=true"
import script from "./GuidelineCoFactor.vue?vue&type=script&lang=js"
export * from "./GuidelineCoFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c5221e",
  null
  
)

export default component.exports